import CookieService from './general/cookie-service';
import LocalStorageService from './general/local-storage-service';

const ActiveEditCacheService = {
  setCurrentEditCookie(editCache: EditCacheCookie) {
    CookieService.set('e-state', editCache);
  },
  getCurrentEditCookie() {
    return CookieService.get('e-state') as EditCacheCookie | undefined;
  },
  resetCurrentEditCookie() {
    CookieService.delete('e-state');
  },

  setMarkdownEditorCache(contentCache: DocumentEditorCache) {
    LocalStorageService.set('act-editor', contentCache);
    return;
  },
  getMarkdownEditorCache() {
    return LocalStorageService.get('act-editor') as unknown as DocumentEditorCache | undefined;
  },
  resetMarkdownEditorCache() {
    LocalStorageService.delete('act-editor');
    return;
  },
};

export default ActiveEditCacheService;
